<template>
  <div class="batch-management">
      <BatchManagementMain v-if="publicData.state === 'main'"/>
      <BatchManagementSubpage v-else/>
  </div>
</template>

<script>
import BatchManagementMain from "modules/finance/batch-management/batch-management-main.vue";
import BatchManagementSubpage from "modules/finance/batch-management/batch-management-subpage.vue";

export default {
  name: "batch-management",
  props: {},
  data() {
    return {
      publicData: { // 公共数据
        state: "main",
        stateName: "首页",
        selectList: [], // 首页选中的数据
      },
      stateNameOptions: [
        {id: "main", text: "首页"},
        {id: "replacement-cost", text: "重置成本"},
        {id: "delivery-supplement", text: "发货补录"},
        {id: "supplement-record", text: "补录"}
      ]
    };
  },
  components: { BatchManagementMain, BatchManagementSubpage },
  provide() {
    return {
      getPublicData: () => this.publicData,
      setPublicData: this.setPublicData
    }
  },
  methods: {
    // 设置公共数据
    setPublicData(type = "all", data) {
      const opt = {
        all: () => {
          Object.assign(this.publicData, data)
          this.publicData.stateName = this.stateNameOptions.find(e => e.id === this.publicData.state).text
        },
        state: () => {
         this.publicData.state = data
         this.publicData.stateName = this.stateNameOptions.find(e => e.id === data).text
        },
        selectList: () => {
         this.publicData.selectList = [...data]
        },
      }
      try {
        opt[type]()
      } catch (error) {
        // console.error("设置公共数据：请出入正确的type");
      }
    }
  },
  created() {},
};
</script>

<style scoped lang='scss'>
.batch-management {
  height: 100%;
}
</style>